import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import * as R from "ramda";

import Emptylustration from '../../../../assets/images/svg/057-contract-1.svg';

import { PaiementClientsTableFilter } from './filter';
import { PaiementClientTableNav } from './nav';
import { PaiementClientTableRow } from './row';
import { LoadingState } from '../../../../_common/loadingState';
import * as Loadings from '../../../../constants/loadings/backoffice/payments';



export const PaiementClientTable = ({ paymentState, pageSearch, setPageSearch, date, setDate, routerQuery }) => {
    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [invoicesToDisplay, setinvoicesToDisplay] = useState(paymentState.clientsInvoices);
    const [filters, setFilters] = useState({
        order: {
            column: "number",
            asc: true
        },
        status: undefined,
        date: {
            startDate: undefined,
            endDate: undefined
        },
        search: "",
    });


    useEffect(() => {



        let temp = paymentState.clientsInvoices;

        // if (!R.isNil(filters.status)) {
        //     temp = temp.filter(client => client.paid === filters.status);
        // }

        // if (filters.order.asc) {

        //     temp = R.sort(R.ascend(R.prop(filters.order.column)), temp);

        // } else {

        //     temp = R.sort(R.descend(R.prop(filters.order.column)), temp);

        // }

        // if (!R.isNil(filters.date.startDate)) {
        //     temp = temp.filter(invoice => invoice.created >= filters.date.startDate);
        // }

        // if (!R.isNil(filters.date.endDate)) {
        //     temp = temp.filter(invoice => invoice.created <= filters.date.endDate);
        // }

        // if (!R.isEmpty(filters.search)) {
        //     temp = temp.filter(invoice => invoice.number?.toLowerCase().includes(filters.search.toLowerCase()) || invoice.recipientName?.toLowerCase().includes(filters.search.toLowerCase()));
        // }


        setinvoicesToDisplay(temp);


    }, [filters, paymentState.clientsInvoices]);


    return (
        <div className="container-fluid h-inherit flex-column">
            <PaiementClientsTableFilter filters={filters} setFilters={setFilters} pageSearch={pageSearch} setPageSearch={setPageSearch} date={date} setDate={setDate} routerQuery={routerQuery} />
            {
                paymentState.isLoading.includes(Loadings.FETCHING_CLIENTS_INVOICES) ?
                    <LoadingState />
                    :
                    <section className="block">
                        {!R.isEmpty(invoicesToDisplay) ?
                            <>
                                <PaiementClientTableNav paymentState={paymentState} routerQuery={routerQuery} />
                                {
                                    invoicesToDisplay.map(invoice => (
                                        <PaiementClientTableRow invoice={invoice} />
                                    ))
                                }
                            </>
                            :
                            <section className="block fs-3 text-center m-auto py-4">
                                <img className="img-fluid img-contain container-paper mx-auto  mt-auto mb-4" src={Emptylustration} alt="Assist@" />
                                <div className="block text-center container-thin mx-auto mb-auto">
                                    <h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas de factures.</h1>
                                </div>
                            </section>
                        }
                    </section>
            }

        </div>
    );
};